import {$qs, $qsAll} from '../../../@shared/ts/dom';
import {type IResponse} from '../../../@type/response';

declare const peachpay_admin: PeachPayAdminData;

function handleAuthnetCaptureVoidForm() {
	const $orderInput = $qs<HTMLInputElement>('#pp-authnet-actions input[name="order_id"]');
	const $amountInput = $qs<HTMLInputElement>('#pp-authnet-actions input[name="amount"]');
	const $captureButton = $qs('#pp-authnet-actions button[name="capture"]');
	const $voidButton = $qs('#pp-authnet-actions button[name="void"]');
	const $error = $qs('.error-message');

	if (!$amountInput || !$orderInput || !$captureButton || !$voidButton || !$error) {
		return;
	}

	const disableForm = () => $qsAll('#pp-authnet-actions input, #pp-authnet-actions button', $e => {
		$e.setAttribute('disabled', 'true');
	});
	const enableForm = () => $qsAll('#pp-authnet-actions input, #pp-authnet-actions button', $e => {
		$e.removeAttribute('disabled');
	});
	const clearStatus = () => {
		$error.innerHTML = '';
	};

	const setStatus = (errorMessage: string) => {
		$error.innerHTML = errorMessage;
	};

	$captureButton.addEventListener('click', async e => {
		e.preventDefault();

		if (!$amountInput.checkValidity()) {
			$amountInput.reportValidity();
			return;
		}

		clearStatus();
		disableForm();

		const orderId = $orderInput.value;
		const amountToCapture = $amountInput.value;

		const formData = new FormData();
		formData.append('action', 'pp-authnet-capture-payment');
		formData.append('security', peachpay_admin.nonces.authnet_capture_payment);
		formData.append('order_id', orderId);
		formData.append('amount_to_capture', amountToCapture);

		const response = await fetch(peachpay_admin.admin_ajax, {
			method: 'POST',
			body: formData,
		});

		const data = await response.json() as IResponse<void>;

		if (!data.success) {
			enableForm();
			setStatus(data.message ?? '');
			return;
		}

		location.reload();
	});

	$voidButton.addEventListener('click', async (e: Event) => {
		e.preventDefault();

		clearStatus();
		disableForm();

		const orderId = $orderInput.value;

		const formData = new FormData();
		formData.append('action', 'pp-authnet-void-payment');
		formData.append('security', peachpay_admin.nonces.authnet_void_payment);
		formData.append('order_id', orderId);

		const response = await fetch(peachpay_admin.admin_ajax, {
			method: 'POST',
			body: formData,
		});

		const data = await response.json() as IResponse<void>;

		if (!data.success) {
			enableForm();
			setStatus(data.message ?? '');
			return;
		}

		location.reload();
	});
}

export {handleAuthnetCaptureVoidForm};
